import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { pageTransitions, transitionDuration } from "../../../../../Util/PageTransitions";
import axiosApi from "../../../../../core/interceptor/interceptor";
import { config } from "../../../../../config";
import WarningDialogue from "../../../../../Util/WarningDialogue";
import "./WebsiteContent.css";
import { Website_Content, EVENT_TYPE } from "../../../../../Util/helper";
import WebsiteContentSection from '../WebsiteContentSection';
import AddWebsiteContent from './AddWebsiteContent';
import { useHistory } from 'react-router-dom';

export default function AdminMenu(props) {
  const history = useHistory();
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popupContent, setPopupContent] = useState({});
  const [viewItemDetails, setViewItemDetails] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [seletedSectionId, setSeletedSectionId] = useState(null);
  const [isNewItem, setIsNewItem] = useState(false);
  const [homeSliders, setHomeSliders] = useState([]);
  const [venues, setVenues] = useState([]);
  const [inclusions, setInclusions] = useState([]);
  const [headline, setHeadline] = useState('');
  const [inclusionHeadline, setInclusionHeadline] = useState('');


  const close = () => {
    setViewItemDetails(false);
  }
  
  const refresh = (flag, type) => {
    if (flag === true) {
      if (type === EVENT_TYPE.HOME_SLIDER) {
        getHomeSlider();
      } else if (type === EVENT_TYPE.VENUE) {
        getVenues();
      } else if (type === EVENT_TYPE.INCLUSION) {
        getInclusions();
      } else if (type === EVENT_TYPE.BACKGROUND) {
        getEventBackground();
      }
    }
  }

  const setAddEditItem = (itemDetails = {
    is_visible: true,
    description: '',
    image: '',
    name: '',
  }, sectionId, newItem = isNewItem) => {
    setViewItemDetails(true);
    setSelectedItem(itemDetails);
    setSeletedSectionId(sectionId);
    setIsNewItem(newItem);
  }

  const getHomeSlider = () => {
    axiosApi.get(`${config.apiUrl}/web-content/home-slider`)
    .then((res) => {
      Website_Content[0].data = res?.data?.data;
      setHomeSliders(res?.data?.data);
    })
  }

  const getVenues = () => {
    axiosApi.get(`${config.apiUrl}/web-content/venues/all`)
    .then((res) => {
      Website_Content[1].data = res?.data?.data;
      setVenues(res?.data?.data);
    })
  }

  const getInclusions = () => {
    axiosApi.get(`${config.apiUrl}/web-content/inclusions`)
    .then((res) => {
      Website_Content[3].data = res?.data?.data;
      setInclusions(res?.data?.data);
    })
  }

  const getHeadline = () => {
    axiosApi.get(`${config.apiUrl}/web-content/headline`)
    .then((res) => {
      setHeadline(res?.data?.data);
    })
  }

  const getInclusionHeadline = () => {
    axiosApi.get(`${config.apiUrl}/web-content/inclusion-headline`)
    .then((res) => {
      setInclusionHeadline(res?.data?.data);
    })
  }

  const getEventBackground = () => {
    axiosApi.get(`${config.apiUrl}/web-content/background`)
    .then((res) => {
      Website_Content[2].data = res?.data?.data;
    })
  }

  useEffect(() => {
    getHomeSlider();
    getVenues();
    getInclusions();
    getInclusionHeadline();
    getHeadline();
    getEventBackground();
  }, [])
  
  return <>
    {viewItemDetails && (
      <AddWebsiteContent
        itemDetails={selectedItem}
        sectionId={seletedSectionId}
        isNewItem={isNewItem}
        onClose={close}
        isAddOrEdit={refresh}
      />
    )}
    <motion.div
      className="adminMenuContainer addMenulist"
      initial={pageTransitions.initial}
      animate={pageTransitions.in}
      exit={pageTransitions.out}
      transition={{ duration: transitionDuration }}
    >
      <div className="content-wrapper menu-wrapper">
        <div className="heading-wrapper">
          <div className="left">
            <h1 className="heading">
              Web Content
            </h1>
          </div>
        </div>
        {Array.isArray(Website_Content) && Website_Content.length > 0 && <div className="admin-menu-section-wrapper">
          {Website_Content.map((value, index) => (
            <div key={index}>
              {value.id === 3 ? 
                <div className="inner-wrapper">
                  <div className="classsifieds  inclusion-headline">
                    <div className="classifieds-left">
                      <h5> Inclusion Headline</h5>
                      <p className="disclaimer" dangerouslySetInnerHTML={{ __html: inclusionHeadline?.text_content }}></p>
                    </div>
                    <div className="classifieds-right">
                      <span style={{
                        color: '00788b',
                        textDecoration: 'underline'
                      }} onClick={() => (history.push(`/admin/events/event-inclusion`))} >Edit</span>
                    </div>
                  </div>
                </div>
                : ''
              }
              <WebsiteContentSection
                sectionTitle={value.name ? value.name : "Untitled Section"}
                sectionIndex={index}
                sectionId={value.id}
                data={value.data ? value.data : []}
                key={`web-content-${index}`}
                setItemDisplay={setAddEditItem}
                isDelete={refresh}
              />
              {value.id === 1 ? 
                <div className="inner-wrapper">
                  <div className="classsifieds Event-headline-block">
                    <div className="classifieds-left">
                      <h5> Headline</h5>
                      <p className="disclaimer" dangerouslySetInnerHTML={{ __html: headline?.text_content }}></p>
                    </div>
                    <div className="classifieds-right">
                      <span style={{
                        color: '00788b',
                        textDecoration: 'underline'
                      }} onClick={() => (history.push(`/admin/events/event-headline`))} >Edit</span>
                    </div>
                  </div>
                </div>
                : ''
              }
            </div>
          ))}
        </div>}
        
      </div>

    </motion.div>
    <WarningDialogue
      isOpen={openWarningPopup}
      header={popupContent.header}
      description={popupContent.description}
      icon={popupContent.icon}
      action={popupContent.action}
      onClose={() => setOpenWarningPopup(false)}
    />
  </>
}